namespace JupitersChoice {
    export class FreeGameModel {

        private _isReturningFrom: boolean;

        constructor() {
            this._isReturningFrom = false;
        }

        get isReturningFrom(): boolean {
            return this._isReturningFrom;
        }

        set isReturningFrom(bool: boolean) {
            this._isReturningFrom = bool;
        }
    }
}